module.exports = __webpack_public_path__ + "img/img20.b7c5a1cf.png";